import Tooltip from './ToolTip'

Tooltip.install = function(Vue) {
	Vue.component(Tooltip.name, Tooltip)
}

export default Tooltip
